export enum WidgetType {
  Image = 'image',
  Text = 'text',
  Socials = 'socials',
  Youtube = 'youtube',
  Soundcloud = 'soundcloud',
  Vimeo = 'video',
  Spotify = 'spotify',
  Twitch = 'twitch',
  Tiktok = 'tiktok',
}
